export default __webpack_public_path__ + "static/HOTDOGPEPE-19261c17ce148f788f830525d7291cdc.png";